export default __webpack_public_path__ + "static/media/g.521c1675.jpg";